import withAuth from '../../../HOC/withAuth';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import WatermarkEditor from '../../../components/WatermarkEditor';
import SettingBar from './SettingBar';
import { normalizeWatermarkEditorConfig } from '../../../watermarkPreviewPolicy';

const Watermark = inject('userStore', 'snackbarStore')(observer(({ userStore, snackbarStore }) => {
  const [wm, setWm] = useState({
    enabled: false, text: '', style: 'single', pos: 'bottom-right',
    size: 36, alpha: 0.4, shadow: false, inset: 24, rotate: 0, weight: 400,
  });
  const wmRef = useRef(wm);
  const repairedLegacyShadowRef = useRef(false);
  const setWmSync = useCallback((newWm) => {
    wmRef.current = newWm;
    setWm(newWm);
  }, []);

  useEffect(() => {
    const next = normalizeWatermarkEditorConfig({
      enabled: userStore.openWatermark || false,
      text: userStore.watermark || '',
      style: userStore.watermarkStyle || 'single',
      pos: userStore.watermarkPosition || 'bottom-right',
      size: userStore.watermarkFontSize || 36,
      alpha: userStore.watermarkAlpha || 0.4,
      shadow: userStore.watermarkShadow ?? false,
      inset: userStore.watermarkInset ?? 24,
      rotate: userStore.watermarkRotate ?? 0,
      weight: 400,
    });
    setWmSync(next);
    if (
      userStore.userInfoLoaded
      && Number(next.rotate) !== 0
      && Boolean(userStore.watermarkShadow)
      && !repairedLegacyShadowRef.current
    ) {
      repairedLegacyShadowRef.current = true;
      userStore.saveWatermarkSetting({
        openWatermark: next.enabled,
        watermark: next.text,
        watermarkStyle: next.style,
        position: next.pos,
        fontSize: next.size,
        watermarkAlpha: next.alpha,
        watermarkShadow: false,
        watermarkInset: next.inset,
        watermarkRotate: next.rotate,
      }).catch(() => {
        repairedLegacyShadowRef.current = false;
        snackbarStore.showSnackbar('旧水印投影配置修正失败，请重试', 'error');
      });
    }
  }, [userStore, userStore.openWatermark, userStore.watermark, userStore.watermarkStyle, userStore.watermarkPosition, userStore.watermarkFontSize, userStore.watermarkAlpha, userStore.watermarkShadow, userStore.watermarkInset, userStore.watermarkRotate, userStore.userInfoLoaded, snackbarStore, setWmSync]);

  const handleSave = useCallback((nextWm) => {
    const current = nextWm && typeof nextWm === 'object' && 'enabled' in nextWm
      ? nextWm
      : wmRef.current;
    userStore.saveWatermarkSetting({
      openWatermark: current.enabled,
      watermark: current.text,
      watermarkStyle: current.style,
      position: current.pos,
      fontSize: current.size,
      watermarkAlpha: current.alpha,
      watermarkShadow: current.shadow,
      watermarkInset: current.inset,
      watermarkRotate: current.rotate,
    }).catch(() => {
      snackbarStore.showSnackbar('保存失败，请重试', 'error');
    });
  }, [userStore, snackbarStore]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <SettingBar />
      <WatermarkEditor wm={wm} onChange={setWmSync} onAutoSave={handleSave} compact settingScope="global"/>
    </div>
  );
}));

export default withAuth(Watermark);
